module.exports = __webpack_public_path__ + "static/media/Sub_Page_CA_header_thankyou.ec9c6a76.jpg";